import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import React, { useCallback, useState, useEffect, useRef } from "react";
import SearchBar from "../../components/SearchBar/SearchBar";
import { useLoading } from "../../contexts/LoadingContext";
import LocationCard from "../../components/LocationCard/LocationCard";
import LocationService, { Location } from "../../services/LocationService";
import "./LocationPage.scss";
import Modal from "../../components/Modal/Modal";
import MapWithMarker from "../../components/MapWithMarker/MapWithMarker";
import noJobInfoGraphics from "./../../assets/images/no-data-infographics.svg";
import { useLoader } from "../../contexts/LoaderContext";

// const sampleLocations: Location[] = [] //For testing Empty

// Sample data for development (replace with API when backend is ready)
const sampleLocations: Location[] = [
  {
    id: 1,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 2,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 3,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 4,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 5,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 6,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 7,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 8,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 9,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 10,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "2025-09-22T06:21:02.404Z",
    updatedAt: "2025-09-22T06:21:02.404Z",
  },
  {
    id: 11,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 12,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 13,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 14,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 15,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 16,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 17,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 18,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 19,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 20,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 21,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 22,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 23,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 24,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/17/24 10:10",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 252,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 112,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 25,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 26,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 27,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 28,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 29,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 30,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 31,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 32,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 33,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 34,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 35,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 36,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 37,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/17/24 10:10",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 38,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 39,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 40,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
  {
    id: 41,
    name: "Kolkata Port",
    address: "Dock 3, Strand Road, Kolkata, West Bengal 700001",
    latitude: 22.5726,
    longitude: 88.3639,
    label: "PORT",
    description: "Port terminal for Kolkata",
    contactPerson: "Arjun Das",
    contactPhone: "+91-9876543277",
    contactEmail: "kolkata@company.com",
    isActive: true,
    createdAt: "03/16/24 15:20",
    updatedAt: "03/16/24 15:20",
  },
  {
    id: 42,
    name: "Ahmedabad Distribution ",
    address: "Sector 21, Gandhinagar, Ahmedabad, Gujarat 382021",
    latitude: 23.0225,
    longitude: 72.5714,
    label: "WAREHOUSE",
    description: "Distribution center for Ahmedabad",
    contactPerson: "Ravi Patel",
    contactPhone: "+91-9876543288",
    contactEmail: "ahmedabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/17/24 10:10",
  },
  {
    id: 43,
    name: "Jaipur North Hub",
    address: "Plot 5, Malviya Nagar, Jaipur, Rajasthan 302017",
    latitude: 26.9124,
    longitude: 75.7873,
    label: "HUB",
    description: "Northern hub for Jaipur",
    contactPerson: "Sunita Sharma",
    contactPhone: "+91-9876543299",
    contactEmail: "jaipur@company.com",
    isActive: true,
    createdAt: "03/18/24 11:45",
    updatedAt: "03/18/24 11:45",
  },
  {
    id: 44,
    name: "Mumbai Central Warehouse",
    address: "123, Andheri Kurla Road, Mumbai, Maharashtra 400059",
    latitude: 19.076,
    longitude: 72.8777,
    label: "WAREHOUSE",
    description: "Main distribution center for Mumbai region",
    contactPerson: "John Doe",
    contactPhone: "+91-9876543210",
    contactEmail: "warehouse@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 45,
    name: "Mumbai Port Terminal",
    address: "456, Port Road, Mumbai, Maharashtra 400001",
    latitude: 18.9217,
    longitude: 72.8347,
    label: "PORT",
    description: "Port terminal for import/export",
    contactPerson: "Jane Smith",
    contactPhone: "+91-9876543211",
    contactEmail: "port@company.com",
    isActive: true,
    createdAt: "03/10/24 10:30",
    updatedAt: "03/10/24 10:30",
  },
  {
    id: 46,
    name: "Pune Distribution Center",
    address: "789, Hinjewadi Road, Pune, Maharashtra 411057",
    latitude: 18.5204,
    longitude: 73.8567,
    label: "WAREHOUSE",
    description: "Distribution center for Pune region",
    contactPerson: "Rahul Mehta",
    contactPhone: "+91-9876543222",
    contactEmail: "pune@company.com",
    isActive: true,
    createdAt: "03/11/24 09:00",
    updatedAt: "03/11/24 09:00",
  },
  {
    id: 47,
    name: "Delhi North Hub",
    address: "101, Connaught Place, New Delhi, Delhi 110001",
    latitude: 28.6304,
    longitude: 77.2177,
    label: "HUB",
    description: "Northern hub for Delhi region",
    contactPerson: "Priya Singh",
    contactPhone: "+91-9876543233",
    contactEmail: "delhi@company.com",
    isActive: true,
    createdAt: "03/12/24 11:30",
    updatedAt: "03/12/24 11:30",
  },
  {
    id: 48,
    name: "Chennai Port",
    address: "202, Marina Beach Road, Chennai, Tamil Nadu 600001",
    latitude: 13.0827,
    longitude: 80.2707,
    label: "PORT",
    description: "Port terminal for Chennai",
    contactPerson: "Suresh Kumar",
    contactPhone: "+91-9876543244",
    contactEmail: "chennai@company.com",
    isActive: true,
    createdAt: "03/13/24 14:45",
    updatedAt: "03/13/24 14:45",
  },
  {
    id: 49,
    name: "Hyderabad Logistics Park",
    address: "Plot 12, Gachibowli, Hyderabad, Telangana 500032",
    latitude: 17.4448,
    longitude: 78.3498,
    label: "PARK",
    description: "Logistics park for Hyderabad",
    contactPerson: "Anil Reddy",
    contactPhone: "+91-9876543255",
    contactEmail: "hyderabad@company.com",
    isActive: true,
    createdAt: "03/14/24 09:30",
    updatedAt: "03/14/24 09:30",
  },
  {
    id: 50,
    name: "Bangalore South Hub",
    address: "No. 7, Electronic City, Bangalore, Karnataka 560100",
    latitude: 12.8452,
    longitude: 77.6604,
    label: "HUB",
    description: "Southern hub for Bangalore",
    contactPerson: "Meera Nair",
    contactPhone: "+91-9876543266",
    contactEmail: "bangalore@company.com",
    isActive: true,
    createdAt: "03/15/24 12:00",
    updatedAt: "03/15/24 12:00",
  },
];

function LocationPage() {
  // const isLoading = useRef(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isMapModalOpen, setisMapModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"create" | "edit" | "view" | null>(
    null
  );
  const [selectedLocationId, setSelectedLocationId] = useState<number | null>(
    null
  );
  const [locationList, setLocationList] = useState<Location[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const page = useRef(0);
  const pageSize = 30;
  const useApi = false; // Set to true to use API when backend is ready
  const gridRef = useRef<HTMLDivElement>(null);

  const loader = useLoading();
  const { showLoader, hideLoader, isLoading: globalLoading } = useLoader();
  const [showTopBarLoader, setShowTopBarLoader] = useState(false);
  const [locationsLoaded, setLocationsLoaded] = useState(false);
  const initialLoadDone = useRef(false);

  // Unified loadLocations for API/sample
  const loadLocations = useCallback(
    async (reset = false) => {
      if (reset) {
        if (!initialLoadDone.current) {
          showLoader();
        }
        setShowTopBarLoader(false);
      } else {
        setShowTopBarLoader(true);
      }
      loader.setLoading(true);
      setLocationsLoaded(false);
      let filtered: Location[] = [];
      if (useApi) {
        try {
          const res = searchQuery
            ? await LocationService.searchLocations({
                q: searchQuery,
                limit: pageSize,
              })
            : await LocationService.getAllLocations({
                limit: pageSize,
                skip: page.current * pageSize,
                search: searchQuery,
              });
          filtered = res.data.data.content || [];
          setLocationList((prev) =>
            reset ? filtered : [...prev, ...filtered]
          );
          if (filtered.length < pageSize) setHasMore(false);
        } catch (err) {
          if (reset) setLocationList([]);
          setHasMore(false);
        }
      } else {
        filtered = sampleLocations.filter(
          (loc: Location) =>
            loc.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            loc.address.toLowerCase().includes(searchQuery.toLowerCase())
        );
        const start = page.current * pageSize;
        const newLocations = filtered.slice(start, start + pageSize);
        setLocationList((prev) =>
          reset ? newLocations : [...prev, ...newLocations]
        );
        if (start + pageSize >= filtered.length) setHasMore(false);
      }
      page.current += 1;
      setTimeout(() => {
        loader.setLoading(false);
        setShowTopBarLoader(false);
        setLocationsLoaded(true);
        if (reset && !initialLoadDone.current) {
          hideLoader();
          initialLoadDone.current = true;
        }
      }, 1000);
    },
    [searchQuery, pageSize, hasMore, useApi, loader, showLoader, hideLoader]
  );

  // Initial load & search
  useEffect(() => {
    setLocationList([]);
    setHasMore(true);
    page.current = 0;
    loadLocations(true);
  }, [searchQuery, useApi]);

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const grid = gridRef.current;
      if (!grid || loader.isLoading || !hasMore) return;
      const { scrollTop, scrollHeight, clientHeight } = grid;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        loadLocations();
      }
    };
    const grid = gridRef.current;
    if (grid) grid.addEventListener("scroll", handleScroll);
    return () => {
      if (grid) grid.removeEventListener("scroll", handleScroll);
    };
  }, [hasMore, loadLocations]);

  const handleSearchChange = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  const handleAssignContainers = () => {
    setModalMode("create");
    setisMapModalOpen(true);
    setSelectedLocationId(null);
  };

  const handleMapSave = async (data: any) => {
    if (modalMode === "edit" && selectedLocationId !== null) {
      await updateLocation(selectedLocationId, {
        name: data.name,
        address: data.address,
        latitude: data.lat,
        longitude: data.lng,
      });
    } else if (modalMode === "create") {
      await createLocation({
        name: data.name,
        address: data.address,
        latitude: data.lat,
        longitude: data.lng,
      });
    }
    setisMapModalOpen(false);
    setModalMode(null);
    setSelectedLocationId(null);
  };

  // Get location by ID (API or sample)
  const getLocationById = async (id: number) => {
    if (useApi) {
      // setLoading(true);
      loader.setLoading(true);
      try {
        const res = await LocationService.getLocationById(id);
        // setLoading(false);
        loader.setLoading(false);

        return res.data.data;
      } catch (err) {
        // setLoading(false);
        loader.setLoading(false);

        return null;
      }
    } else {
      return sampleLocations.find((loc) => loc.id === id) || null;
    }
  };

  // Create location (API or sample)
  const createLocation = async (data: Partial<Location>) => {
    if (useApi) {
      // setLoading(true);
      loader.setLoading(true);

      try {
        const res = await LocationService.createLocation(data);
        setLocationList((prev) => [res.data.data, ...prev]);
      } catch (err) {}
      // setLoading(false);
      loader.setLoading(false);
    } else {
      setLocationList((prev) => [
        {
          id: prev.length ? Math.max(...prev.map((l) => l.id)) + 1 : 1,
          ...data,
          label: "WAREHOUSE",
          isActive: true,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        } as Location,
        ...prev,
      ]);
    }
  };

  // Update location (API or sample)
  const updateLocation = async (id: number, data: Partial<Location>) => {
    if (useApi) {
      // setLoading(true);
      loader.setLoading(true);

      try {
        await LocationService.updateLocation(id, data);
        setLocationList((prev) =>
          prev.map((loc) => (loc.id === id ? { ...loc, ...data } : loc))
        );
      } catch (err) {}
      // setLoading(false);
      loader.setLoading(false);
    } else {
      setLocationList((prev) =>
        prev.map((loc) => (loc.id === id ? { ...loc, ...data } : loc))
      );
    }
  };

  // Delete location (API or sample) with confirm dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState<Location | null>(
    null
  );

  const handleDeleteLocation = (location: Location) => {
    setLocationToDelete(location);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteLocation = async () => {
    if (!locationToDelete) return;
    if (useApi) {
      loader.setLoading(true);
      try {
        await LocationService.deleteLocation(locationToDelete.id);
        setLocationList((prev) =>
          prev.filter((loc) => loc.id !== locationToDelete.id)
        );
      } catch (err) {}
      loader.setLoading(false);
    } else {
      setLocationList((prev) =>
        prev.filter((loc) => loc.id !== locationToDelete.id)
      );
    }
    setDeleteDialogOpen(false);
    setLocationToDelete(null);
  };

  // Helper to get location by id from current list
  const getLocationByIdLocal = (id: number) =>
    locationList.find((loc) => loc.id === id);

  return (
    <div className="transporters-page p-[20px]">
      <div className="flex justify-between items-center py-[30px]">
        <SearchBar
          placeholder="Search Location..."
          onSearch={handleSearchChange}
          showClearButton={true}
        />
        <div className="flex items-center space-x-2">
          <button
            type="button"
            className="primary_button"
            onClick={handleAssignContainers}
          >
            Create New
          </button>
        </div>
        <Modal
          className="assign_containers_modal"
          title={
            modalMode === "edit"
              ? "Edit Location"
              : modalMode === "view"
              ? "View Location"
              : "Assign Containers"
          }
          isOpen={isMapModalOpen}
          onClose={() => {
            setisMapModalOpen(false);
            setModalMode(null);
            setSelectedLocationId(null);
          }}
        >
          {(modalMode === "edit" || modalMode === "view") &&
          selectedLocationId !== null ? (
            (console.log("modalMode", modalMode),
            (
              <MapWithMarker
                initialLatLng={{
                  lat:
                    getLocationByIdLocal(selectedLocationId)?.latitude ??
                    19.076,
                  lng:
                    getLocationByIdLocal(selectedLocationId)?.longitude ??
                    72.8777,
                }}
                initialName={
                  getLocationByIdLocal(selectedLocationId)?.name || ""
                }
                initialAddress={
                  getLocationByIdLocal(selectedLocationId)?.address || ""
                }
                onSave={
                  modalMode === "edit"
                    ? handleMapSave
                    : () => setisMapModalOpen(false)
                }
                mode={modalMode}
              />
            ))
          ) : (
            <MapWithMarker onSave={handleMapSave} />
          )}
        </Modal>
      </div>
      <div>
        {globalLoading && !locationsLoaded && !initialLoadDone.current ? (
          <FullPageLoader />
        ) : (
          <>
            {showTopBarLoader && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background:
                    "linear-gradient(90deg, #007bff 0%, #00c6ff 100%)",
                  zIndex: 1000,
                  animation: "loader-bar 1s linear infinite",
                }}
              />
            )}
            <div
              className="location-card-grid"
              ref={gridRef}
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              {locationList.map((location) => (
                <LocationCard
                  key={location.id}
                  data={location}
                  onEdit={() => {
                    setModalMode("edit");
                    setisMapModalOpen(true);
                    setSelectedLocationId(location.id);
                  }}
                  onDelete={() => handleDeleteLocation(location)}
                  onView={() => {
                    setModalMode("view");
                    setisMapModalOpen(true);
                    setSelectedLocationId(location.id);
                  }}
                />
              ))}
              <ConfirmDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                onConfirm={confirmDeleteLocation}
                title="Delete Location"
                message={`Are you sure you want to delete location ${locationToDelete?.name}? This action cannot be undone.`}
                confirmText="Delete"
                cancelText="Cancel"
                confirmColor="error"
              />
              {loader.isLoading && locationsLoaded && (
                <div style={{ textAlign: "center", padding: 16 }}>
                  Loading...
                </div>
              )}
            </div>
            {locationsLoaded &&
              !loader.isLoading &&
              locationList.length === 0 && (
                <div className="center_floater_container">
                  <div className="no_data_wrapper">
                    <img
                      className="info_graphics"
                      src={noJobInfoGraphics}
                      alt="No Location"
                    />
                    <div className="msg">No Locations </div>
                  </div>
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
}

export default LocationPage;
